import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Tabs, Chip, Person, fmt, when, Modal, img } from "./kit";
import kopyalaPano from "../../util/kopyala";

/// KASA — yayinci odemeleri tek yerde: cekim talepleri ve odeme hesabi dogrulama.
const DURUM = {
  0: ["warn", "Bekliyor"],
  1: ["ok", "Onaylandı"],
  2: ["bad", "Reddedildi"],
};


/// 3 Kas: odeme hesabi karti (modern). Yonteme gore renkli hesap blogu, kontrol ozeti, kopyala.
const KZ_CSS = `
.kz{--kz-bg:#fff;--kz-fg:#0f172a;--kz-mut:#64748b;--kz-line:#e2e8f0;--kz-soft:#f1f5f9;--kz-ok:#16a34a;--kz-warn:#d97706;--kz-bad:#dc2626;font-family:-apple-system,BlinkMacSystemFont,"Inter","Segoe UI",sans-serif;color:var(--kz-fg)}
.kz-bar{display:flex;flex-wrap:wrap;gap:12px;align-items:center;justify-content:space-between;margin:14px 0 18px}
.kz-seg{display:inline-flex;background:var(--kz-soft);border-radius:12px;padding:4px;gap:2px}
.kz-seg button{border:0;background:transparent;padding:8px 16px;border-radius:9px;font-size:13px;font-weight:600;color:var(--kz-mut);cursor:pointer;display:flex;gap:8px;align-items:center;transition:all .15s}
.kz-seg button.on{background:#fff;color:var(--kz-fg);box-shadow:0 1px 3px rgba(15,23,42,.12)}
.kz-seg i{font-style:normal;background:#ef4444;color:#fff;border-radius:999px;font-size:11px;padding:1px 7px}
.kz-search{border:1px solid var(--kz-line);border-radius:12px;padding:9px 14px;font-size:13px;min-width:260px;outline:none;background:#fff}
.kz-search:focus{border-color:#6366f1;box-shadow:0 0 0 3px rgba(99,102,241,.15)}
.kz-stats{display:grid;grid-template-columns:repeat(auto-fit,minmax(170px,1fr));gap:12px;margin-bottom:18px}
.kz-stat{background:#fff;border:1px solid var(--kz-line);border-radius:16px;padding:14px 16px;display:flex;gap:12px;align-items:center}
.kz-stat b{font-size:24px;line-height:1;font-weight:750;letter-spacing:-.02em}
.kz-stat span{font-size:12px;color:var(--kz-mut);display:block;margin-top:4px}
.kz-dot{width:38px;height:38px;border-radius:12px;display:grid;place-items:center;font-size:17px}
.kz-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(360px,1fr));gap:16px}
.kz-card{background:var(--kz-bg);border:1px solid var(--kz-line);border-radius:20px;padding:18px;display:flex;flex-direction:column;gap:14px;box-shadow:0 1px 2px rgba(15,23,42,.04);transition:box-shadow .2s,transform .2s;position:relative}
.kz-card:hover{box-shadow:0 12px 28px -12px rgba(15,23,42,.18);transform:translateY(-1px)}
.kz-head{display:flex;gap:12px;align-items:center}
.kz-ava{width:46px;height:46px;border-radius:14px;object-fit:cover;background:linear-gradient(135deg,#e2e8f0,#cbd5e1);flex:none}
.kz-name{font-weight:700;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.kz-tags{display:flex;flex-wrap:wrap;gap:6px;margin-top:4px}
.kz-tag{font-size:11px;font-weight:600;padding:2px 8px;border-radius:999px;background:var(--kz-soft);color:var(--kz-mut)}
.kz-tag.red{background:#fee2e2;color:var(--kz-bad)}
.kz-pill{margin-left:auto;font-size:11px;font-weight:700;padding:5px 10px;border-radius:999px;white-space:nowrap}
.kz-pill.s0{background:#fef3c7;color:#92400e}.kz-pill.s1{background:#dcfce7;color:#166534}.kz-pill.s2{background:#fee2e2;color:#991b1b}
.kz-acc{border-radius:16px;padding:16px;color:#fff;position:relative;overflow:hidden}
.kz-acc:after{content:"";position:absolute;right:-40px;top:-40px;width:140px;height:140px;border-radius:50%;background:rgba(255,255,255,.08)}
.kz-acc.iban{background:linear-gradient(135deg,#1e3a8a,#3b82f6)}.kz-acc.usdt{background:linear-gradient(135deg,#065f46,#10b981)}
.kz-acc.papara{background:linear-gradient(135deg,#4c1d95,#8b5cf6)}.kz-acc.wu{background:linear-gradient(135deg,#78350f,#f59e0b)}
.kz-acc small{font-size:10px;letter-spacing:.12em;text-transform:uppercase;opacity:.75;font-weight:700}
.kz-row{display:flex;align-items:center;gap:8px;justify-content:space-between;position:relative;z-index:1}
.kz-num{font-family:"SF Mono",ui-monospace,Menlo,monospace;font-size:14px;letter-spacing:.04em;word-break:break-all;margin:6px 0 10px}
.kz-holder{font-weight:700;font-size:14px;letter-spacing:.02em;text-transform:uppercase}
.kz-copy{border:0;background:rgba(255,255,255,.18);color:#fff;border-radius:9px;width:30px;height:30px;display:grid;place-items:center;cursor:pointer;flex:none;transition:background .15s}
.kz-copy:hover{background:rgba(255,255,255,.3)}
.kz-checks{border:1px solid var(--kz-line);border-radius:14px;overflow:hidden}
.kz-sum{display:flex;align-items:center;gap:10px;padding:10px 12px;cursor:pointer;font-size:13px;font-weight:600;user-select:none}
.kz-bar2{flex:1;height:6px;background:var(--kz-soft);border-radius:99px;overflow:hidden}
.kz-bar2 div{height:100%;border-radius:99px}
.kz-fail{display:flex;flex-direction:column;gap:6px;padding:0 12px 10px}
.kz-it{display:flex;gap:8px;align-items:flex-start;font-size:12.5px}
.kz-ic{width:18px;height:18px;border-radius:6px;display:grid;place-items:center;font-size:11px;font-weight:800;flex:none;color:#fff}
.kz-meta{font-size:11.5px;color:var(--kz-mut);display:flex;flex-wrap:wrap;gap:4px 12px}
.kz-act{display:flex;gap:8px}
.kz-btn{flex:1;border-radius:12px;padding:10px 14px;font-size:13px;font-weight:700;cursor:pointer;border:1px solid transparent;transition:all .15s}
.kz-btn.ok{background:#16a34a;color:#fff}.kz-btn.ok:hover{background:#15803d}
.kz-btn.no{background:#fff;color:var(--kz-bad);border-color:#fecaca}.kz-btn.no:hover{background:#fef2f2}
.kz-btn:disabled{opacity:.5;cursor:default}
.kz-note{font-size:12px;background:#fef2f2;color:#991b1b;border-radius:10px;padding:8px 10px}
.kz-empty{text-align:center;padding:60px 20px;color:var(--kz-mut);background:#fff;border:1px dashed var(--kz-line);border-radius:20px}
.kz-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#0f172a;color:#fff;padding:10px 18px;border-radius:12px;font-size:13px;font-weight:600;z-index:9999;box-shadow:0 10px 30px rgba(0,0,0,.25)}
`;
const KopyaIkon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
);
const gruplu = (v, tur) => (tur === "iban" ? String(v || "").replace(/(.{4})/g, "$1 ").trim() : String(v || ""));
const DURUM_AD = { 0: "Onay bekliyor", 1: "Onaylı", 2: "Reddedildi" };

const HesapKart = ({ p, isleniyor, onayla, reddet, kopyala }) => {
  const h = p.host || {};
  const [acik, setAcik] = useState(p.eksik > 0 || Number(p.status) === 0);
  const k = p.kontroller || [];
  const gecen = k.filter((x) => x.ok).length;
  const renk = p.eksik > 0 ? "#dc2626" : p.uyari > 0 ? "#d97706" : "#16a34a";
  const sorunlu = k.filter((x) => !x.ok);
  return (
    <div className="kz-card" style={{ boxShadow: p.eksik > 0 ? "0 0 0 2px #fecaca" : undefined }}>
      <div className="kz-head">
        {h.image ? <img className="kz-ava" src={img(h.image)} alt="" /> : <div className="kz-ava" />}
        <div style={{ minWidth: 0 }}>
          <div className="kz-name">{h.name || "Sahibi bulunamadı"}</div>
          <div className="kz-tags">
            {h.uniqueID ? <span className="kz-tag">ID {h.uniqueID}</span> : <span className="kz-tag red">Hesap silinmiş</span>}
            {h.rol ? <span className="kz-tag">{h.rol}</span> : null}
            {h.country ? <span className="kz-tag">{String(h.country).toUpperCase()}</span> : null}
            {h.ajansli ? <span className="kz-tag">Ajanslı</span> : null}
            {h.engelli ? <span className="kz-tag red">Engelli</span> : null}
          </div>
        </div>
        <span className={`kz-pill s${Number(p.status)}`}>{DURUM_AD[Number(p.status)]}</span>
      </div>

      <div className={`kz-acc ${p.type}`}>
        <div className="kz-row">
          <small>{p.typeName}{p.extra?.banka ? ` · ${p.extra.banka}` : ""}{p.extra?.ulke ? ` · ${p.extra.ulke}` : ""}</small>
        </div>
        <div className="kz-row">
          <div className="kz-num">{gruplu(p.account, p.type)}</div>
          <button className="kz-copy" title="Hesabı kopyala" onClick={() => kopyala(p.account, "Hesap kopyalandı")}><KopyaIkon /></button>
        </div>
        <div className="kz-row">
          <div className="kz-holder">{p.holder}</div>
          <button className="kz-copy" title="Adı kopyala" onClick={() => kopyala(p.holder, "Ad kopyalandı")}><KopyaIkon /></button>
        </div>
      </div>

      <div className="kz-checks">
        <div className="kz-sum" onClick={() => setAcik(!acik)}>
          <span style={{ color: renk }}>{p.eksik > 0 ? "Eksik / hatalı" : p.uyari > 0 ? "Kontrol et" : "Temiz"}</span>
          <div className="kz-bar2"><div style={{ width: `${k.length ? (gecen / k.length) * 100 : 0}%`, background: renk }} /></div>
          <span style={{ color: "#64748b", fontSize: 12 }}>{gecen}/{k.length}</span>
          <span style={{ color: "#94a3b8", transform: acik ? "rotate(90deg)" : "none", transition: "transform .15s" }}>›</span>
        </div>
        {acik && (
          <div className="kz-fail">
            {(sorunlu.length ? sorunlu : k).concat(sorunlu.length ? k.filter((x) => x.ok) : []).map((x, i) => (
              <div key={i} className="kz-it" style={{ opacity: x.ok ? 0.55 : 1 }}>
                <span className="kz-ic" style={{ background: x.ok ? "#16a34a" : x.uyari ? "#d97706" : "#dc2626" }}>{x.ok ? "✓" : x.uyari ? "!" : "✕"}</span>
                <span>{x.ad}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {p.note ? <div className="kz-note">Not: {p.note}</div> : null}
      <div className="kz-meta">
        <span>Eklendi {when(p.createdAt)}</span>
        {p.verifiedAt ? <span>Onay {when(p.verifiedAt)}</span> : null}
        {h.uyelik ? <span>Üyelik {when(h.uyelik)}</span> : null}
      </div>

      <div className="kz-act">
        {Number(p.status) !== 1 && (
          <button className="kz-btn ok" disabled={isleniyor} onClick={onayla}>{p.eksik > 0 ? "Yine de onayla" : "Onayla"}</button>
        )}
        {Number(p.status) !== 2 && (
          <button className="kz-btn no" disabled={isleniyor} onClick={reddet}>Reddet</button>
        )}
      </div>
    </div>
  );
};

const Vault = () => {
  const [tab, setTab] = useState("accounts");
  const [durum, setDurum] = useState("0");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [secili, setSecili] = useState(null);
  const [not, setNot] = useState("");
  const [isleniyor, setIsleniyor] = useState(false);
  const [ara, setAra] = useState("");
  const [toast, setToast] = useState("");
  const kopyala = (v, mesaj) => {
    const bitti = () => {
      setToast(mesaj);
      setTimeout(() => setToast(""), 1600);
    };
    kopyalaPano(v).then((ok) => {
      if (ok) return bitti();
      setToast("Kopyalanamadı");
      setTimeout(() => setToast(""), 1600);
    });
  };

  const load = useCallback(async () => {
    setLoading(true);
    const res =
      tab === "requests"
        ? await api.redeemList({ type: { 0: "pending", 1: "solved", 2: "decline" }[durum] })
        : await api.payoutAccounts({ status: durum });
    if (res?.status) setData(res);
    else setData({});
    setLoading(false);
  }, [tab, durum]);

  useEffect(() => {
    load();
  }, [load]);

  const hesapKarar = async (id, status) => {
    setIsleniyor(true);
    const r = await api.payoutAction(id, { status, note: not });
    setIsleniyor(false);
    setSecili(null);
    setNot("");
    if (r?.status) load();
    else alert(r?.message || "İşlem yapılamadı.");
  };

  const cekimKarar = async (id, status) => {
    if (!window.confirm(status === 1 ? "Ödeme yapıldı olarak işaretlensin mi?" : "Talep reddedilsin mi? Elmas yayıncıya iade edilir.")) return;
    setIsleniyor(true);
    const r = await api.redeemAction(id, status === 1 ? "accept" : "decline");
    setIsleniyor(false);
    if (r?.status) load();
    else alert(r?.message || "İşlem yapılamadı.");
  };

  const talepler = data.redeem || data.rows || [];
  const q = ara.trim().toLowerCase();
  // sorunlu hesaplar uste
  const hesaplar = (data.rows || [])
    .filter((p) => !q || [p.host?.uniqueID, p.host?.name, p.holder, p.account, p.extra?.banka, p.typeName].some((x) => String(x || "").toLowerCase().includes(q)))
    .sort((a, b) => (b.eksik - a.eksik) || (b.uyari - a.uyari));
  const bekleyenToplam = talepler
    .filter((t) => Number(t.status) === 0)
    .reduce((s, t) => s + (Number(t.coin) || 0), 0);

  return (
    <>
      <PageHead title="Kasa" sub="Çekim talepleri ve yayıncı ödeme hesapları. Para yalnızca onaylı hesaba gönderilir." />

      <Tabs
        value={tab}
        onChange={(t) => {
          setTab(t);
          setDurum("0");
          setData({});
        }}
        tabs={[
          ["accounts", "Ödeme hesapları"],
          ["requests", "Çekim talepleri"],
        ]}
      />

      <style>{KZ_CSS}</style>
      <div className="kz kz-bar">
        <div className="kz-seg">
          {[
            ["0", "Bekleyen"],
            ["1", "Onaylı"],
            ["2", "Reddedilen"],
          ].map(([k, ad]) => (
            <button key={k} className={durum === k ? "on" : ""} onClick={() => setDurum(k)}>
              {ad}
              {k === "0" && tab === "accounts" && data.pending > 0 ? <i>{data.pending}</i> : null}
            </button>
          ))}
        </div>
        {tab === "accounts" && <input className="kz-search" placeholder="Ara: ID, ad, IBAN, banka…" value={ara} onChange={(e) => setAra(e.target.value)} />}
      </div>

      {tab === "requests" ? (
        <>
          <Tiles
            items={[
              { label: "Listelenen talep", value: fmt(talepler.length) },
              { label: "Bekleyen tutar (elmas)", value: fmt(bekleyenToplam) },
            ]}
          />
          <Table
            loading={loading}
            head={["Yayıncı", "Tutar", "Yöntem", "Hesap bilgisi", "Tarih", "Durum", ""]}
            empty="Bu durumda talep yok."
            rows={talepler.map((t) => {
              const [kind, ad] = DURUM[Number(t.status)] || DURUM[0];
              return (
                <tr key={t._id}>
                  <td>
                    <Person p={t.hostId || t.host} />
                  </td>
                  <td>
                    <b>{fmt(t.coin)}</b>
                  </td>
                  <td>{t.paymentGateway || "—"}</td>
                  <td style={{ maxWidth: 260, whiteSpace: "pre-wrap", fontSize: 12 }}>{t.description || "—"}</td>
                  <td>{when(t.createdAt)}</td>
                  <td>
                    <Chip kind={kind}>{ad}</Chip>
                  </td>
                  <td>
                    {Number(t.status) === 0 && (
                      <div style={{ display: "flex", gap: 6 }}>
                        <button className="badu-btn primary" disabled={isleniyor} onClick={() => cekimKarar(t._id, 1)}>
                          Ödendi
                        </button>
                        <button className="badu-btn" disabled={isleniyor} onClick={() => cekimKarar(t._id, 2)}>
                          Reddet
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          />
        </>
      ) : (
        <>
          <div className="kz">
            <div className="kz-stats">
              {[
                ["#eef2ff", "🗂", fmt(hesaplar.length), "Listelenen hesap"],
                ["#fef3c7", "⏳", fmt(data.pending || 0), "Onay bekleyen"],
                ["#fee2e2", "⛔", fmt(hesaplar.filter((r) => r.eksik > 0).length), "Eksik / hatalı"],
                ["#ffedd5", "⚠️", fmt(hesaplar.filter((r) => !r.eksik && r.uyari > 0).length), "Kontrol edilecek"],
              ].map(([bg, ik, v, l]) => (
                <div key={l} className="kz-stat">
                  <div className="kz-dot" style={{ background: bg }}>{ik}</div>
                  <div><b>{v}</b><span>{l}</span></div>
                </div>
              ))}
            </div>
            {loading ? (
              <div className="kz-empty">Yükleniyor…</div>
            ) : !hesaplar.length ? (
              <div className="kz-empty">{ara ? "Aramaya uyan hesap yok." : durum === "0" ? "Onay bekleyen hesap yok. 🎉" : "Bu durumda hesap yok."}</div>
            ) : (
              <div className="kz-grid">
                {hesaplar.map((p) => (
                  <HesapKart key={p._id} p={p} isleniyor={isleniyor} kopyala={kopyala} onayla={() => hesapKarar(p._id, 1)} reddet={() => setSecili(p)} />
                ))}
              </div>
            )}
            {toast ? <div className="kz-toast">{toast}</div> : null}
          </div>
        </>
      )}

      <Modal open={!!secili} title="Hesabı reddet" onClose={() => setSecili(null)}>
        <p style={{ fontSize: 13, opacity: 0.8 }}>
          Yayıncıya gösterilecek kısa bir sebep yaz. Hesap bilgisi yanlışsa düzeltip tekrar gönderebilir.
        </p>
        <textarea
          className="badu-input"
          rows={3}
          value={not}
          placeholder="Örn: Hesap sahibinin adı, yayıncı adıyla eşleşmiyor."
          onChange={(e) => setNot(e.target.value)}
        />
        <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
          <button className="badu-btn primary" disabled={isleniyor} onClick={() => hesapKarar(secili._id, 2)}>
            Reddet
          </button>
          <button className="badu-btn" onClick={() => setSecili(null)}>
            Vazgeç
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Vault;
